import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";

// MainShell 走 lazy：main entry 不静态依赖 antd / antd-mobile / utils 全家
const mainShellPromise = import("./MainShell");
const MainShell = lazy(() => mainShellPromise);

// 提前发起 HomePage import，与 MainShell 并行下载（同 promise 缓存被复用，不会重复请求）
import("../pages/HomePage").catch(() => {});

/** RR 6.30+ 运行时支持 v7_startTransition；部分版本的 FutureConfig 类型未收录该字段 */
type CreateBrowserRouterFuture = NonNullable<
  NonNullable<Parameters<typeof createBrowserRouter>[1]>["future"]
> & { v7_startTransition?: boolean };

export const router = createBrowserRouter(
  [
    {
      path: "/*",
      element: (
        <Suspense fallback={null}>
          <MainShell />
        </Suspense>
      ),
    },
  ],
  {
    future: { v7_startTransition: true } as CreateBrowserRouterFuture,
  }
);
